var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 6,
  fill: "none",
  viewBox: "0 0 14 6"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.57 5.605a1 1 0 0 1-1.14 0L.97 1.822C.164 1.264.559 0 1.54 0h10.92c.981 0 1.376 1.264.57 1.822z"
})));
export { SvgArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDE0IDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03LjU2OTUgNS42MDU0NEM3LjIyNjkyIDUuODQyNzggNi43NzMwOCA1Ljg0Mjc4IDYuNDMwNTEgNS42MDU0NEwwLjk2OTU3MSAxLjgyMkMwLjE2Mzg1NyAxLjI2Mzc4IDAuNTU4ODcxIC02LjgxNzczZS0wOSAxLjUzOTA2IDcuODg3MzVlLTA4TDEyLjQ2MDkgMS4wMzM2OWUtMDZDMTMuNDQxMSAxLjExOTM4ZS0wNiAxMy44MzYxIDEuMjYzNzggMTMuMDMwNCAxLjgyMkw3LjU2OTUgNS42MDU0NFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";